/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_History_AllInputs */

const vi_vehicle_gps_history_all = /** @type {(inputs: Vehicle_Gps_History_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn bộ hành trình`)
};

/**

* @param {Vehicle_Gps_History_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_history_all = /** @type {((inputs?: Vehicle_Gps_History_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_History_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_history_all(inputs)
});